<template>
  <div class="orderTasksContainer">
    <v-progress-circular indeterminate v-if="loading" />

    <v-row style="width: 100%" v-else>
      <v-col :key="index" v-for="(task, index) in tasks" cols="6">
        <TaskDetailsCard
            v-if="task && task.type === 'task'"
            :task="task.data"
        />

        <ImportLiveTaskCard
            v-else-if="task && task.type === 'shopifyTask'"
            :task="task.data"
        />

        <v-card class="taskNotPushedCard" v-else>
          <h2>
            Task not Imported <br />
            into TaskDash yet
          </h2>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../../fb";

import TaskDetailsCard from "@/components/TaskCards/TaskDetailsCard";
import ImportLiveTaskCard from "@/components/TaskCards/ImportLiveTaskCard";

export default {
  name: "OrderTasks",

  components: {
    TaskDetailsCard,
    ImportLiveTaskCard,
  },

  data() {
    return {
      loading: false,
      tasks: [],
    };
  },

  props: {
    orderTasks: {
      required: true,
    },
  },

  mounted() {
    this.loadLineItems();
  },

  methods: {
    async loadLineItems() {
      this.loading = true;
      this.tasks = [];

      for await (const task of this.orderTasks) {
        const taskUid = task.taskUid;

        const taskDoc = doc(db, `tasks/${taskUid}`);
        const taskRef = await getDoc(taskDoc);

        if (taskRef.exists()) {
          this.tasks.push({
            type: "task",
            data: {
              id: taskRef.id,
              ...taskRef.data(),
            },
          });

          continue;
        }

        const shopifyTaskDoc = doc(db, `shopifyTasks/${taskUid}`);
        const shopifyTaskRef = await getDoc(shopifyTaskDoc);

        if (shopifyTaskRef.exists()) {
          this.tasks.push({
            type: "shopifyTask",
            data: {
              id: shopifyTaskRef.id,
              ...shopifyTaskRef.data(),
            },
          });

          continue;
        }

        this.tasks.push(null);
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.orderTasksContainer {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 24px;
}

.taskNotPushedCard {
  height: 100%;
  min-height: 400px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>